var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66953 20.4005L21.1195 12.9205C21.9295 12.5705 21.9295 11.4305 21.1195 11.0805L3.66953 3.60051C3.00953 3.31051 2.27953 3.80051 2.27953 4.51051L2.26953 9.12051C2.26953 9.62051 2.63953 10.0505 3.13953 10.1105L17.2695 12.0005L3.13953 13.8805C2.63953 13.9505 2.26953 14.3805 2.26953 14.8805L2.27953 19.4905C2.27953 20.2005 3.00953 20.6905 3.66953 20.4005Z",
    fill: "#6271DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.af99118600f4cebff2ddc0d32fe97ffd.svg";
export { ForwardRef as ReactComponent };